import API from './API';

let store = {
  userAttributes: null,

};

class UserData {
  static clearStore = () => {
    store.userAttributes = null;
  }

  static getUserAttributes = () => {
    if (store.userAttributes !== null) {
      return Promise.resolve(store.userAttributes);
    }
    return API.getUserAttributes()
      .then(userAttributes => {
        store.userAttributes = userAttributes;
        return Promise.resolve(store.userAttributes);
      })
  }
}

export default UserData;